.stepper {
  display: flex;
  align-items: flex-start;
}

.step {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  gap: var(--mantine-spacing-xs);
  min-width: 0;
}

/* Connector line joining this step's dot center to the previous step's dot center. */
.step:not(:first-child)::before {
  content: '';
  position: absolute;
  top: 9px;
  right: 50%;
  left: -50%;
  height: var(--mantine-spacing-0_25);
  background: var(--adl-border-light);
}

.stepConnectorFilled::before {
  background: var(--adl-status-inform-medium);
}

.dot {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: var(--mantine-radius-xl);
  background: var(--adl-surface-container);
}

.dotDashedRing {
  position: absolute;
  inset: 0;
  stroke: var(--adl-border-medium);
}

.dotCompleted {
  border: var(--mantine-spacing-0_25) solid var(--adl-status-inform-medium);
  background: var(--adl-status-inform-medium);
}

.dotActive {
  border: 3px solid var(--adl-status-inform-medium);
  background: var(--adl-surface-container);
}

.dotException {
  border: var(--mantine-spacing-0_25) solid var(--adl-status-warning-medium);
  background: var(--adl-status-warning-medium);
}

.dotCheck {
  width: 9px;
  height: 9px;
  color: var(--adl-status-inform-white);
}

.dotIcon {
  width: 9px;
  height: 9px;
  color: var(--adl-status-warning-white);
}

.stepLabel {
  font-size: var(--mantine-font-size-xs);
  color: var(--adl-text-secondary);
  text-align: center;
}

.stepLabelActive {
  color: var(--adl-status-inform-medium);
  font-weight: 600;
}

.stepLabelException {
  color: var(--adl-status-warning-medium);
  font-weight: 600;
}

.stepLabelCompleted {
  color: var(--adl-status-inform-medium);
}

.proRow {
  display: flex;
  align-items: center;
  gap: var(--mantine-spacing-xs);
  margin-top: var(--mantine-spacing-md);
}

.proLabel {
  font-size: var(--mantine-font-size-sm);
  font-weight: 600;
  color: var(--adl-text-primary);
}

.proLink {
  display: inline-flex;
  align-items: center;
  gap: var(--mantine-spacing-xs);
}

.updates {
  margin-top: var(--mantine-spacing-md);
}

.event {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--mantine-spacing-md);
}

.event + .event {
  margin-top: var(--mantine-spacing-sm);
}

.eventText {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-0_25);
  min-width: 0;
}

.eventWhen {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-0_25);
  align-items: flex-end;
  text-align: right;
  white-space: nowrap;
}

.eventStatus {
  font-size: var(--mantine-font-size-sm);
  font-weight: 600;
  color: var(--adl-text-primary);
}

.eventMeta {
  font-size: var(--mantine-font-size-sm);
  color: var(--adl-text-secondary);
}
